/**
 * Progresso in parole, non in barre: "Parte 3 di 12". Il blocco ("Le sue giornate")
 * e testo normale sopra, mai un pretitolo maiuscolo spaziato (DESIGN-TOKENS §3.3).
 * Vive nella fascia sfumata della direzione 03.
 */
export type ProgressWordsProps = {
  block: string
  /** Numeri (preferito) o frase gia composta, es. "Parte 3 di 12". */
  progress: { current: number; total: number } | string
}

export function progressLabel(current: number, total: number): string {
  return `Parte ${current} di ${total}`
}

export function ProgressWords({ block, progress }: ProgressWordsProps) {
  const label = typeof progress === 'string' ? progress : progressLabel(progress.current, progress.total)
  return (
    <div className="surface-band mb-[18px] flex flex-col gap-1 rounded-card px-[22px] pb-[26px] pt-[22px]">
      <span className="text-band text-ink">{block}</span>
      <span className="text-meta text-ink">{label}</span>
    </div>
  )
}
